import styled from 'styled-components';
import formatCurrency from '../../../../utils/formatCurrency';
import { convertToLocalTime } from '../../../../utils/convertToLocalTime';
import FontAwesomeIcon from '../../../common/FontAwesomeIcon';

// StatusChip component for payment status
const StatusChip = ({ status }) => {
    const getStatusColor = (status) => {
        return status ? '#28A986' : '#EE7872';
    };

    return (
        <StatusChipContainer color={getStatusColor(status)}>
            {status ? 'Activa' : 'Inactiva'}
        </StatusChipContainer>
    );
};

const FinanceItem = (props) => {
    const { finance } = props;

    const vouchersSorted = [...(finance?.vouchers || [])].sort(
        (a, b) => (Date.parse(b?.date) || 0) - (Date.parse(a?.date) || 0)
    );

    // RETURN
    return (
        <FinanceItemContainer>
            <FinanceItemHeader>
                <label>PROGRAMA</label>
                <p>{finance?.program_name}</p>
            </FinanceItemHeader>
            <FinanceItemBody>
                <span>
                    <label>IMPORTE TOTAL</label>
                    <h5>{formatCurrency(finance?.total_amount_usd)}</h5>
                </span>
                {finance?.payment_methods
                    ?.map((method) => method?.currency)
                    ?.includes('USD') && (
                    <CurrencyAlertContainer>
                        <FontAwesomeIcon
                            icon="fa-light fa-circle-exclamation"
                            size={22}
                            color={'#b31d15'}
                        />
                        <h5>
                            Tenga en cuenta que si ha realizado pagos en moneda
                            local, distinta a USD, puede haber diferencias en el
                            saldo debido a la tasa de conversión del día de
                            pago.
                        </h5>
                    </CurrencyAlertContainer>
                )}
                {finance?.payment_methods.length > 0 && (
                    <>
                        <label>MIS FORMAS DE PAGO</label>
                        <TableContainer>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>ESTADO</Th>
                                        <Th>FORMA DE PAGO</Th>
                                        <Th>LINK DE PAGO</Th>
                                        <Th>TOTAL A PAGAR</Th>
                                        <Th>CANTIDAD DE CUOTAS</Th>
                                        <Th>VALOR DE LA CUOTA</Th>
                                        <Th>ESTADO DEL PAGO</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {finance?.payment_methods?.map(
                                        (row, index) => (
                                            <Tr key={index}>
                                                <Td>
                                                    <StatusChip
                                                        status={row?.is_active}
                                                    />
                                                </Td>
                                                <Td>{row?.payment_method}</Td>
                                                <Td>
                                                    <a
                                                        href={row?.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {row?.link}
                                                    </a>
                                                </Td>
                                                <Td>
                                                    {row?.currency}{' '}
                                                    {formatCurrency(
                                                        row?.total_usd,
                                                        ''
                                                    )}
                                                </Td>
                                                <Td>{row?.installments}</Td>
                                                <Td>
                                                    {row?.currency}{' '}
                                                    {formatCurrency(
                                                        row?.installment_value,
                                                        ''
                                                    )}
                                                </Td>
                                                <Td>{row?.status}</Td>
                                            </Tr>
                                        )
                                    )}
                                </tbody>
                            </Table>
                        </TableContainer>
                    </>
                )}
                <label>MIS COMPROBANTES</label>
                {finance?.vouchers?.length > 0 ? (
                    <TableContainer>
                        <Table>
                            <thead>
                                <tr>
                                    <Th>FECHA DE PAGO</Th>
                                    <Th>IMPORTE ABONADO</Th>
                                    <Th>NÚMERO DE COMPROBANTE</Th>
                                    <Th>NÚMERO DE RECIBO</Th>
                                </tr>
                            </thead>
                            <tbody>
                                {vouchersSorted?.map((row, index) => (
                                    <Tr key={index}>
                                        <Td>
                                            {convertToLocalTime(
                                                row?.date,
                                                '',
                                                true
                                            )}
                                        </Td>
                                        <Td>
                                            {row?.currency === 'PAB'
                                                ? 'USD'
                                                : row?.currency}{' '}
                                            {formatCurrency(row?.amount, '')}
                                        </Td>
                                        <Td>{row?.voucher_number}</Td>
                                        <Td>{row?.receipt_number}</Td>
                                    </Tr>
                                ))}
                            </tbody>
                        </Table>
                    </TableContainer>
                ) : (
                    <i>
                        Aquí podrás ver y descargar los comprobantes de los
                        pagos que has realizado.
                    </i>
                )}
            </FinanceItemBody>
        </FinanceItemContainer>
    );
};

export default FinanceItem;

const FinanceItemContainer = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: start;
    background-color: #fff;
    border-radius: 20px;
    box-shadow:
        0px 12px 24px -15px #0000001a,
        0px 0px 10px -6px #00000040;
`;

const FinanceItemHeader = styled.header`
    width: calc(100% - 4rem);
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 1rem;
    background-color: #b31d15;
    border-radius: 20px 20px 0 0;
    color: #fff;
    padding: 0 2rem;

    label {
        font-size: 16px;
    }

    p {
        font-size: 20px;
        font-weight: 700;
    }
`;

const FinanceItemBody = styled.div`
    width: calc(100% - 4rem);
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 2rem;
    padding: 2rem;

    span {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        label {
            font-size: 16px;
            color: #222;
        }

        h5 {
            font-size: 20px;
            font-weight: 700;
            color: #b31d15;
        }
    }

    label {
        font-size: 16px;
        color: #222;
        font-weight: 400;
    }
`;

const Table = styled.table`
    border-radius: 20px;
    border-spacing: 0;
    border: 1px solid #616161;
    width: 100%;

    thead {
        tr:first-child {
            th:first-child {
                border-radius: 20px 0 0 0;
            }
            th:last-child {
                border-radius: 0 20px 0 0;
            }
        }
    }
`;

const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Th = styled.th`
    padding: 2rem 1rem;
    text-align: left;
    text-align: center;
    border-bottom: 1px solid #616161;
    color: #616161;
    background-color: #f1f1f1;
    font-size: 13px;
    white-space: nowrap;

    &:first-child {
        th:first-child {
            border-radius: 0 0 0 20px;
        }
        th:last-child {
            border-radius: 0 0 20px 0;
        }
    }
`;

const Td = styled.td`
    padding: 8px;
    text-align: ${(props) => (props.align === 'start' ? 'start' : 'center')};
    padding: 2rem 0;
    border-bottom: 1px solid #a8a8a8;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    a {
        color: #222;
        text-decoration: underline;
    }
`;

const Tr = styled.tr`
    &:last-child {
        border-radius: 0 0 20px 20px;
        td:first-child {
            border-radius: 0 0 0 20px;
        }
        td:last-child {
            border-radius: 0 0 20px 0;
        }
    }
`;

const StatusChipContainer = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 700;
    color: white;
    background-color: ${(props) => props.color};
    text-transform: capitalize;
    min-width: 80px;
    height: 24px;
`;

const CurrencyAlertContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 0.5rem;
    h5 {
        font-size: 14px;
        font-weight: 700;
        font-style: italic;
        color: #b31d15;
    }
`;
